interface SingularFaqListProps {
  points: string[];
}

export const SingularFaqList = ({ points }: SingularFaqListProps) => (
  <ul className="list-disc pl-4 mb-4">
    {points.map((point) => (
      <li key={`singular-faq-list-${point}`}>
        <span>{point}</span>
      </li>
    ))}
  </ul>
);
